export default "./images/survio-z6gHu-assets-reference-hu.png";